import { createApp, defineAsyncComponent } from 'vue';

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
// import CookiesMsg from './plugins/cookies-msg/index.js';
import SiteDrawer from './plugins/site-drawer/index.js';

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS
import ImageEditor from './components/image-editor/index.vue';
const FleetTable = defineAsyncComponent(() => import('./fleet-table.vue'));
// import bsModal from 'bootstrap/js/dist/modal';

/////////////////////////////////////////////////////////////////////////////////////////////////// APP

// import { devices, viewportSize } from './imports/utils';
import Animations from './animations.js';

createApp({
    mixins: [Animations],
    components: {
        ImageEditor,
        FleetTable
    },
    data() {
        return {
            scrollTop: 0,
            mainMenuShow: false,
            // isDevice: devices(),
            // viewportSize: viewportSize(),
            collapseShown: false,
        }
    },
    methods: {
        onScroll() {
            this.mainMenuShow = false;
            this.scrollTop = window.scrollY;
        },
        // onResize() {
        //     this.viewportSize = viewportSize();
        // },
        // showModal(id) {
        //     const modalEl = document.getElementById(id);

        //     new bsModal(modalEl).show();

        //     // modalEl.addEventListener('shown.bs.modal', event => {});

        //     // modalEl.addEventListener('hidden.bs.modal', event => {});
        // },
        // showCollapse(id) {
        //     this.bsCollapse = new bsCollapse(`#${id}`, {
        //         toggle: false
        //     });

        //     this.bsCollapse.show();

        //     const myCollapsible = document.getElementById(id);

        //     myCollapsible.addEventListener('shown.bs.collapse', event => {
        //         this.toElement(id);
        //     });

        //     this.collapseShown = id;
        // },
        // hideCollapse(id) {
        //     this.bsCollapse.hide();
        //     this.bsCollapse = null;
        //     this.collapseShown = null;
        // },
        // toggleCollapse(id) {
        //     new bsCollapse(`#${id}`, {
        //         toggle: true
        //     }).show();

        //     if (this.collapseShown === id) {
        //         this.collapseShown = null;
        //     } else {
        //         this.collapseShown = id;
        //     }
        // },
        // scrollTo(id) {
        //     const top = document.getElementById(id).offsetTop;

        //     window.scrollTo({
        //         top: top - 200,
        //         behavior: 'smooth'
        //     });
        // },
    },
    created() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')

        window.addEventListener("scroll", this.onScroll, {
            passive: true
        });

        // window.addEventListener("resize", this.onResize, {
        //     passive: true
        // });

        // if (this.isDevice) document.querySelector("html").classList.add("device");
    },
    destroyed() {
        window.removeEventListener("scroll", this.onScroll);
        // window.removeEventListener("resize", this.onResize)
    }
})
    // .use(CookiesMsg)
    .use(SiteDrawer)
    .mount('#app')